module.exports = __webpack_public_path__ + "img/143.7.940221ab.png";